export default __webpack_public_path__ + "static/img-mobile-8be047137fb9afd6edf4ee4f1bd9b779.png";